<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{Translate('Create Thermography Inspection')}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Inspection">close</i>
  </div>



  <div class="ttmodal__body">
    <div *ngIf="isInspector" style="width: 500px;">

     
      <mat-form-field class="setup-form-full-width">
        <input matInput  [min]="EquipmentSetupDate"  [max]="todate"  readonly [matDatepicker]="myDatepicker" placeholder="{{'Select Inspection Date' | translate | async}}"  [(ngModel)]="dateReplaced" >
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="setup-form-full-width">
          <input type="number" min="0" matInput placeholder="{{'SMU' | translate | async}}"  [(ngModel)]="selectedSMU">
        </mat-form-field>

          <div *ngIf="!isValid">
              {{Translate('Please enter valid SMU')}}
            </div>
      <div class="ttmodal__footer">
          <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
          <button mat-raised-button color="warn"  (click)="CreateInspection()"><span class="material-icons button__icon">check</span><span
              class="button__text">{{Translate('Start Inspection')}}</span></button>
        </div>
    </div>

    <div *ngIf="!isInspector">
      {{Translate('Please check your user permissions, Only inspector or super user can create inspections')}}
      <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
    </div>





  </div>


  

</div>